export default [{"tag":"path","att":{"d":"M2 6h2v12H2V6zm12 6 8 6.0005v-12L14 12zm-9 0 8 6.0005v-12L5 12z"}}]